import { AfterContentInit, Component, OnInit } from '@angular/core';
import { AbstractDataProvider } from '../AbstractDataProvider';
import { ActivatedRoute } from '@angular/router';
import { QueryStringParam, SecurityQuestionAnswer } from '../security/QueryStringParam';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { DictionaryPipe } from '../../shared/pipes/dictionary.pipe';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import {getErrorMessageText} from '../helper';

@Component({
  selector: 'app-security-question',
  templateUrl: './security-question.component.html',
  styleUrls: ['./security-question.component.scss'],
  providers: [DictionaryPipe]
})
export class SecurityQuestionComponent implements OnInit {

  queryParamList: Array<QueryStringParam> = [];
  questionList = [{SecQuestionText: 'dd', SecQuestionCode: 'CD1'}];

  securityQuestionAnswer: SecurityQuestionAnswer = new SecurityQuestionAnswer();
  secQuestionNum: number;
  alertMessage: string;
  display = false;
  isSuccess = false;


  constructor(private abstractDataProvider: AbstractDataProvider,
              private authService: AuthServiceCustom,
              private route: ActivatedRoute,
              private ngxService: NgxUiLoaderService,
              private dictionaryPipe: DictionaryPipe) {
    this.route.queryParams.subscribe(queryParam => {
      for (const key in queryParam) {
        this.queryParamList.push({Key: key, Value: queryParam[key]});
      }
    });
  }


  ngOnInit() {
    this.getListOfSecurityQuestions();
  }


  navigateHome() {
    this.authService.navigateToLogin();
  }

  getListOfSecurityQuestions() {
    this.abstractDataProvider.getData('api/Configuration/GetSecurityQuestionList').subscribe(
      (posts) => {
        this.questionList = posts.SecurityQuestions;
      },
      (error) => {
        this.display = true;
        this.alertMessage =  getErrorMessageText(error);
      }
    );
  }

  submitTheAnswer() {
    if (this.validateAnswer()) {
      this.abstractDataProvider.postData(this.securityQuestionAnswer, 'api/Configuration/SaveSecurityQuestionForUser').subscribe(
        (posts) => {
          this.display = true;
          if (posts.SaveStatus) {
            this.alertMessage = this.dictionaryPipe.transform('SECURITY_QUESTIONS_SETUP_COMPLETED');
            this.authService.navigateToUrl('home');
          } else {
            this.alertMessage = this.dictionaryPipe.transform('SECURITY_QUESTIONS_SETUP_FAILED');
          }
        },
        (error) => {
          this.display = true;
          this.alertMessage =  getErrorMessageText(error);
           }
      );
    }
  }

  validateAnswer() {
    const validatedObj = this.authService.validateSecurityQuestionAnswer(this.securityQuestionAnswer);
    if (validatedObj.isValid === false) {
      this.display = true;
      this.alertMessage = validatedObj.alertmessage;
    }
    return validatedObj.isValid;
  }

  afterAllProcessDone() {
    const returnUrlKey = this.queryParamList.filter((d) => d.Key === 'returnUrl');
    if (returnUrlKey && returnUrlKey.length > 0) {
      this.authService.navigateToUrl(returnUrlKey[0].Value);
      return;
    }
    this.authService.navigateToUrl('home');
  }


}
